import { useSearch } from '@tanstack/react-router';

import { useCurrentPageIndexContext } from '../../components/providers/CurrentPageIndexProvider';

export function useCurrentPageIndex() {
  const currentPageIndexFromContext = useCurrentPageIndexContext();
  const params = useSearch({ strict: false });

  if (currentPageIndexFromContext !== null) {
    return currentPageIndexFromContext;
  }

  return String(params.page ?? 1);
}
